// extracted by mini-css-extract-plugin
export default {"scroller":"Scroller_scroller__4Lqra"};